import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import Label from "./LabelF";
import { validarRegex } from "../../../context/FuncionesContext";
import NoteTaker from "../../../components/NoteTaker";
import { TextareaAutosize } from "@mui/material";
import { getAtributo } from "../../../context/FuncionesContext";
import Nullifier from "../../../components/Nullifier";

const InputText = (props) => {
  const { setValor, valor, cab, error, setError, data, number, textarea } =
    props;
  const {
    id,
    id_a,
    margin_bottom_abm,
    permite_null,
    width,
    maximo_caracteres,
    min_width,
    input_size,
  } = cab;
  const clasico = getAtributo("textarea_clasico", data, cab) === "s";
  const prefijo_usar = getAtributo("prefijo_usar", data, cab) === "s";
  const prefijo = getAtributo("prefijo", data, cab) ?? "";
  const valorString = typeof valor === "string" ? valor : "";
  const valorSinPrefijo =
    prefijo_usar && valorString.startsWith(prefijo)
      ? valorString.slice(prefijo.length)
      : valorString;

  useEffect(() => {
    let mydefault = data[id_a] ?? data[id_a + "_default"] ?? cab.default;
    if (!valor) {
      const valorInicial =
        prefijo_usar &&
        typeof mydefault === "string" &&
        !mydefault.startsWith(prefijo)
          ? prefijo + mydefault
          : mydefault;
      setValor(valorInicial);
    }
  }, [cab.default, data, id_a, prefijo, prefijo_usar, setValor, valor]);

  if (cab.textarea_toolbar === "s") {
    return <NoteTaker {...props} />;
  }

  const handleInput = (e) => {
    let { value } = e.target;

    if (cab.solo_mayus === "s") {
      value = value.toUpperCase();
    }
    if (value.length > maximo_caracteres) return;
    if (prefijo_usar) {
      setValor(prefijo + value);
      setError((e) => {
        return { ...e, [id_a]: false };
      });
      return;
    }

    setValor(value);
    setError((e) => {
      return { ...e, [id_a]: false };
    });
  };

  const handleOnBlur = (e) => {
    const valor = e.target.value
    const max =
      cab.valor_maximo && cab.valor_maximo !== ""
        ? Number(cab.valor_maximo)
        : undefined;
    const min =
      cab.valor_minimo && cab.valor_minimo !== ""
        ? Number(cab.valor_minimo)
        : undefined;

    if ((max || cab.valor_maximo !== "") && Number(valor) > max) {
      return setError((e) => {
        return { ...e, [id_a]: Number(valor) > max };
      });
    }

    if ((min || cab.valor_minimo !== "") && Number(valor) < min) {
      return setError((e) => {
        return { ...e, [id_a]: Number(valor) < min };
      });
    }

    if (validarRegex(valor, cab.validacion_regex, cab)) {
      setError((e) => {
        return { ...e, [id_a]: false };
      });
      return;
    }
    setError((e) => {
      return { ...e, [id_a]: true };
    });
  };

  const handleNull = () => {
    setValor("null");

    setError((e) => {
      return { ...e, [id_a]: false };
    });
  };

  const handleEnterKeyDown = (e) => {
    if (e.key === "Enter" && (textarea || clasico)) {
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  const style_input_abm = {
    // width: "100%",
    marginBottom: margin_bottom_abm,
    width: cab.width_input || input_size || width || (prefijo_usar ? "60%" : "100%"),
    minWidth: input_size || min_width,
  };

  return (
    <>
      {cab.nombre ? (
        <Label
          label={cab.nombre}
          opcionales_null={cab.opcionales_null}
          permite_null={cab.permite_null}
        />
      ) : (
        <></>
      )}
      {clasico ? (
        <TextareaAutosize
          id={id}
          type={cab.input_type ?? (number ? "number" : "text")}
          placeholder={cab.placeholder}
          onChange={handleInput}
          onKeyDown={handleEnterKeyDown}
          onBlur={handleOnBlur}
          helperText={error[id_a] ? cab.helper_text : ""}
          label={cab.label}
          value={prefijo_usar ? valorSinPrefijo : valor ?? ""}
          error={error[id_a]}
          multiline={textarea}
          maxRows={500}
          minRows={2}
          variant="outlined"
          size="small"
          className={cab.className}
          inputProps={{
            style: {
              textTransform: cab.solo_mayus === "s" ? "uppercase" : "inherit",
            },
            maxLength: cab.maximo_caracteres,
            className: "textfield_input_text_number",
          }}
          style={style_input_abm}
          disabled={
            data[cab.id_a + "_disabled"]
              ? data[cab.id_a + "_disabled"] === "s"
              : cab.disabled === "s"
          }
        />
      ) : (
        <>
          {prefijo_usar ? <TextField value={prefijo} disabled style={{ backgroundColor: '#99989861', width: "39%", margin: '0 2px 0 0' }} /> : <></>}
          <TextField
            id={id}
            type={cab.input_type ?? (number ? "number" : "text")}
            placeholder={cab.placeholder}
            onChange={handleInput}
            onKeyDown={handleEnterKeyDown}
            onBlur={handleOnBlur}
            FormHelperTextProps={{ style: { position: "absolute", top: "2rem", width: "max-content", margin: "0.3rem" } }}
            helperText={error[id_a] ? cab.helper_text : ""}
            label={cab.label}
            value={prefijo_usar ? valorSinPrefijo : valor ?? ""}
            error={error[id_a]}
            multiline={textarea}
            maxRows={500}
            minRows={2}
            variant="outlined"
            size="small"
            className={cab.input_class_caja}
            inputProps={{
              style: {
                textTransform: cab.solo_mayus === "s" ? "uppercase" : "inherit",
              },
              maxLength: cab.maximo_caracteres,
              className: cab.input_class_text + " textfield_input_text_number",
            }}
            style={style_input_abm}
            disabled={
              data[cab.id_a + "_disabled"]
                ? data[cab.id_a + "_disabled"] === "s"
                : cab.disabled === "s"
            }
          />
        </>
      )}
      {permite_null === "s" ? (
        <Nullifier onClick={handleNull} className="columna_input_null" />
      ) : (
        <></>
      )}
    </>
  );
};
export default InputText;
